import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/ErrorLayout.scss';

const ErrorLayout = ({ children }) => (
  <div className={styles.ErrorLayout}>
    <div className={styles.main}>
      { children }
    </div>
  </div>
);

ErrorLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorLayout;
